module.exports = __webpack_public_path__ + "static/media/banner-voala-flexibilidade-ca.b3a12eab.jpg";